// Client-side mirror of the backend PESEL check — for instant feedback only; the API validates again.
const WEIGHTS = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];

export function isValidPesel(value: string): boolean {
  if (!/^\d{11}$/.test(value)) {
    return false;
  }
  const digits = value.split("").map(Number);
  const sum = WEIGHTS.reduce((acc, w, i) => acc + w * (digits[i] ?? 0), 0);
  if ((10 - (sum % 10)) % 10 !== digits[10]) {
    return false;
  }

  const rawMonth = Number(value.slice(2, 4));
  const centuries = [1900, 2000, 2100, 2200, 1800];
  const century = centuries[Math.floor(rawMonth / 20)];
  const month = rawMonth % 20;
  const day = Number(value.slice(4, 6));
  if (century === undefined || month < 1 || month > 12) {
    return false;
  }
  const year = century + Number(value.slice(0, 2));
  const daysInMonth = new Date(year, month, 0).getDate();
  return day >= 1 && day <= daysInMonth;
}
